package com.trevorwiebe.timesheet.admin.equipment.presentation

import com.trevorwiebe.timesheet.mileage.domain.model.Equipment

enum class EquipmentFilter { TRUCK, TRAILER, ACTIVE, INACTIVE, DELETED }
enum class EquipmentSort { UNIT_NUMBER, MILES_SINCE_SERVICE }

data class EquipmentState(
    val equipment: List<Equipment> = emptyList(),
    val activeFilters: Set<EquipmentFilter> = setOf(EquipmentFilter.TRUCK, EquipmentFilter.TRAILER, EquipmentFilter.ACTIVE),
    val activeSort: EquipmentSort? = EquipmentSort.UNIT_NUMBER,
    val serviceStatusMap: Map<String, Long> = emptyMap(),
    val isLoadingServiceStatus: Boolean = false,
    val showAddEditDialog: Boolean = false,
    val editingEquipment: Equipment? = null,
    val showMakeActiveDialog: Boolean = false,
    val isLoading: Boolean = false,
    val error: String? = null
)
